import React, { useEffect, useState } from 'react'
import { ColumnVisitor } from '../../components/general/general-component/columns-component/ColumnVisitor'
import { AbstructVar } from '../../components/general/general-component/abstruct-component/AbstructVar'
import SectionTopOfTable from '../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import { useSelectorCustom } from '../../components/general/general-component/abstruct-component/useSelectorCustom'
import InnerLoader from '../../components/general/inner-loader/InnerLoader'
import { VariableVisitor } from './VariableVisitor'
import AddVisitor from './AddVisitor'
import { blockVisitor, deleteVisitor, loadVisitors } from '../../store/Actions/ActionVisitor'
import { AbstructLang } from '../../components/general/general-component/abstruct-component/AbstructLang'
import { DeleteComponent } from '../../components/general/general-component/abstruct-component/DeleteComponent'
import Warning from '../../components/general/general-component/warning-delete/Warning'
import EditVisitor from './EditVisitor'
import FilterVisitor from './FilterVisitor'
import Table2 from '../../components/table/Table2'
import { UsePermissions, hasPermissions } from '../../components/general/general-component/abstruct-component/UsePermissions'
import CheckPermissions from '../../components/general/general-component/check-permissions'
import CheckLazyLoader from '../../components/general/general-component/check-lazy-loader'

const Visitors = () => {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const visitorss = hasPermissions([{ name: "visitors" }], permissionss);
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { visitors, loadingVisitors } = useSelectorCustom()
    const { state, setOpen, handleEdit, setopenEdit } = VariableVisitor()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [visitorsArr, setVisitorsArr] = useState([])
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...visitorsArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setVisitorsArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, visitorsArr]);
    useEffect(() => {
        if (visitors?.length >= 0) {
            setVisitorsArr(visitors)
        }
    }, [visitors]);

    useEffect(() => {
        dispatch(loadVisitors())
    }, []);

    const handleDelete = (id) => {
        dispatch(deleteVisitor(id, setloadDel, setIsDeleted, setIdDeleted));
    }

    const openAddVisitor = e => {
        e.preventDefault()
        setOpen(true)
    }
    const editStatus = (id, status) => {
        let newStatus;
        if (status === 1) {
            newStatus = 0
        } else {
            newStatus = 1
        }
        dispatch(blockVisitor(id, newStatus, setloadDel));
    }

    const { columns } = ColumnVisitor(translate, warning, handleEdit, editStatus, langLocal)

    return (
        <CheckLazyLoader  route='/dashboard/visitors' >
            {
                <CheckPermissions array={visitorss} loadingMainPermission={loadingMainPermission} >
                <main>
                    <FilterVisitor translate={translate} />
                    <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                        <SectionTopOfTable langLocal={langLocal} title={translate('visitors')} titleBtn={translate('addvisitor')} FunctionBtn={openAddVisitor} />
                        {
                            loadingVisitors == false ? (
                                <Table2 col={columns} roo={visitorsArr} />
                            ) : <InnerLoader />
                        }
                    </div>
                </main>
                </CheckPermissions>
            }

            {
                state.open && (
                    <AddVisitor open={state.open} setOpen={setOpen} />
                )
            }
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
            {
                state.openEdit && (
                    <EditVisitor arr={state.arr1} open={state.openEdit} setOpen={setopenEdit} />
                )
            }
        </CheckLazyLoader>
    )
}

export default Visitors
